import { useMemo } from 'react';

// material-ui
import { Theme } from '@mui/material/styles';
import { Box, useMediaQuery } from '@mui/material';

// project import
import Search from './Search';
import Message from './Message';
import Profile from './Profile';
import Localization from './Localization';
import Notification from './Notification';
import Customization from './Customization';
import MobileSection from './MobileSection';
import MegaMenuSection from './MegaMenuSection';
import useConfigContext from 'context/useConfigContext';
import DrawerHeader from '../..//Drawer/DrawerHeader';

// type
import { LAYOUT_CONST } from 'types/ConfigType';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
	const { i18n, menuOrientation } = useConfigContext();

	const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const localization = useMemo(() => <Localization />, [i18n]);

	const megaMenu = useMemo(() => <MegaMenuSection />, []);

	return (
		<>
			{ menuOrientation === LAYOUT_CONST.HORIZONTAL_LAYOUT && !downLG && <DrawerHeader open={ true } /> }
			{ !downLG && <Search /> }
			{/* { !downLG && megaMenu }
			{ !downLG && localization } */}
			{ downLG && <Box sx={ { width: '100%', ml: 1 } } /> }

			{/* <Notification />
			<Message /> */}
			{/*<Customization />*/}
			{ !downLG && <Profile /> }
			{ downLG && <MobileSection /> }
		</>
	);
};

export default HeaderContent;
